<template>
	<div class="finance container-fluid py-2">
		<div class="row">
			<div class="col-md-12 p-0">
				<el-card shadow="never" class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div slot="header" class="clearfix">
						<span><strong>Monitoring COGS</strong></span>
					</div>
					<div>
						<div class="row">
							<div class="mb-3">          
								<el-collapse style="margin-top: -21px;">
									<el-collapse-item>
										<template slot="title">
											<span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
										</template>
										<el-form label-position="top" label-width="100px" class="ml-4">
											<div class="row">
												<div class="col-md-6">
													<el-form-item label="Branch:">
														<el-select v-model="branchId" clearable filterable placeholder="Select Branch" size="medium" style="width:100%;" name="branchid">
															<el-option v-for="item3 in options.branchlist" :key="item3.BranchID" :label="item3.BranchName" :value="item3.BranchID">
															</el-option>
														</el-select>
													</el-form-item>
												</div>
												<div class="col-md-6">
													<el-form-item label="Category Name:">
														<el-select v-model="categoryname" clearable filterable placeholder="Select Category Name" size="medium" style="width:100%;" name="CategoryName">
															<el-option v-for="item3 in options.categorynamelist" :key="item3.CategoryName" :label="item3.CategoryName" :value="item3.CategoryName">
															</el-option>
														</el-select>
													</el-form-item>
												</div>
											</div>
											<div class="row">
												<div class="col-md-4">
													<el-form-item label="Category Type:">
														<el-select v-model="categorytype" clearable filterable placeholder="Select Category Type" size="medium" style="width:100%;" name="categorytype">
															<el-option v-for="item3 in options.categorytypelist" :key="item3.CategoryType" :label="item3.CategoryType" :value="item3.CategoryType">
															</el-option>
														</el-select>
													</el-form-item>
												</div>
												<div class="col-md-4">
													<el-form-item label="Tag Product:">
														<el-select v-model="tagproduct" clearable filterable placeholder="Select Tag Product" size="medium" style="width:100%;" name="tagproduct">
															<el-option v-for="item3 in options.tagproductlist" :key="item3.TagProduct" :label="item3.TagProduct" :value="item3.TagProduct">
															</el-option>
														</el-select>
													</el-form-item>
												</div>
												<div class="col-md-4">
													<el-form-item label="Keterangan:">
														<el-select v-model="keterangan" clearable filterable placeholder="Select Keterangan" size="medium" style="width:100%;" name="keterangan">
															<el-option v-for="item3 in options.keteranganlist" :key="item3.Keterangan" :label="item3.Keterangan" :value="item3.Keterangan">
															</el-option>
														</el-select>
													</el-form-item>
												</div>
											</div>

											<div class="row">
												<div class="col-md-6">
													<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
												</div>
											</div>

										</el-form>
									</el-collapse-item>
								</el-collapse>
							</div>
						</div>

						<div class="row">
							<div class="col-md-3">
								<el-checkbox v-model="showchart">Show Chart</el-checkbox>
							</div>
						</div>
						<div class="mb-3 d-flex flex-row justify-content-center align-items-center">
							<BarChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="350" v-if="showchart && charttype=='barchart'" />
							<LineChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="192" v-if="showchart && charttype=='linechart'" style="margin-top:20px;"/>
							<PieChart v-loading.body="loading.piechart" :data="piechartdata" :url="''" v-if="showchart && charttype=='piechart'" style="width:400px;" />
						</div>

						<div class="mb-3" style="margin-top:0px;">   
							<div class="mt-0">
                                <ReportResultTable :reportname="'PLReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/>                           
                            </div>
						</div>
					</div>
				</el-card>	
			</div>
		</div>

	</div>
</template>

<script>

import Bright from '@/components/page/Bright.js'
import ReportResultTable from '@/views/pages/ReportResultTable3.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import PieChart from '@/components/chart/Pie.js'

export default
{
	extends: Bright,
	components: { 
		ReportResultTable,
		LineChart,
		BarChart,
		PieChart,
		//VendorReportTab,
		//FinanceReportTab,
        //Loader,
	},

	data(){
		return {
            loading: {
				table: false,
				chart: false,
				isSuccess: false,
				piechart: false,
			},
            reportdata: [],
            urlRequestParams: '',
            dialogVisible: false,
			showchart: false,
			charttype: 'piechart',
			chartdata: [],
			piechartdata: [],

			branchId:'',
			categoryname: '',
			categorytype:'',
			tagproduct:'',
			keterangan:'',

			options: {
				branchlist:[],
				categorynamelist: [],
				categorytypelist: [],
				tagproductlist: [],
				keteranganlist: [],
			}
		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },
	}, 
    mounted()
    {
        this.$emit('childrenRoute');
        this.loadData()
		this.getPiechart()
    },
    methods:{
        async loadData() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams+='/finance/monitoring-cogs?'

			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End
			//this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			//this.urlRequestParams+='&date-range-end='+ this.dateRange[1]

			this.urlRequestParams+='&branch='+this.branchId
			this.urlRequestParams+='&category-name='+this.categoryname
			this.urlRequestParams+='&category-type='+this.categorytype
			this.urlRequestParams+='&tag-product='+this.tagproduct
			this.urlRequestParams+='&keterangan='+this.keterangan

			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
					this.loading.isSuccess = true;

					if(this.options.branchlist.length <=0 ) {
						this.branchList()
						this.categoryNameList()
						this.categoryTypeList()
						this.tagProductList()
						this.tagProductList()
						this.keteranganList()
					}
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },

		getPiechart() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/finance/monitoring-cogs-pie-chart?'
			
			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End
			/*
			this.urlRequestParams+='&branch='+this.filter.branch
			this.urlRequestParams+='&branchto='+this.filter.branchto
			if (this.filter.dateRange !== null && this.filter.dateRange.length > 0) {
			this.urlRequestParams+='&startDate='+ this.filter.dateRange[0]
			this.urlRequestParams+='&endDate='+ this.filter.dateRange[1]
			}
			*/

			this.urlRequestParams+='&branch='+this.branchId
			this.urlRequestParams+='&category-name='+this.categoryname
			this.urlRequestParams+='&category-type='+this.categorytype
			this.urlRequestParams+='&tag-product='+this.tagproduct
			this.urlRequestParams+='&keterangan='+this.keterangan

			this.loading.piechart = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{ 
				//this.chartresponsedata = response.data.data;
				//this.chartdata = this.processBarChart(this.chartresponsedata, "legend", "", "price", false, "period", "", 1, 2, Rainbow, false, false, false, this.stacked);
			
				let responsedata = response.data.data
				
				let item = responsedata
				var warna = []
				let value = [];
				let idx = 0;
				for (var row in item) {
					//add color
					warna[item[row].Keterangan] = Rainbow[idx];//'#FFB22E'

					//add value
					let main = {
						transtype: item[row].Keterangan, 
						amount: item[row].cnt,
					};

					value.push(main);
					idx++;
				}

				this.piechartdata = this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				this.loading.piechart = false;
			})

		},

		branchList() {
			const groupedData = [];
			this.reportdata.data.forEach((item) => {
				const branchKey = item.BranchID //`${item.BranchID} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.branchKey === branchKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.CategoryName);
				} else {
					groupedData.push({
						branchKey,
						BranchID: item.BranchID,
						BranchName: item.BranchName
					});
				}
			});

			this.options.branchlist = groupedData
			//console.log('groupedData: ' + JSON.stringify(groupedData))

			//return groupedData;
		},

		categoryNameList() {
			const groupedData = [];
			this.reportdata.data.forEach((item) => {
				const branchKey = item.CategoryName //`${item.CategoryID} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.branchKey === branchKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.CategoryName);
				} else {
					groupedData.push({
						branchKey,
						//CategoryName: item.CategoryName,
						CategoryName: item.CategoryName
					});
				}
			});

			this.options.categorynamelist = groupedData
			//return groupedData;
		},

		categoryTypeList() {
			const groupedData = [];
			this.reportdata.data.forEach((item) => {
				const branchKey = item.CategoryType //`${item.CategoryID} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.branchKey === branchKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.CategoryType);
				} else {
					groupedData.push({
						branchKey,
						//CategoryType: item.CategoryType,
						CategoryType: item.CategoryType
					});
				}
			});

			this.options.categorytypelist = groupedData
			//return groupedData;
		},

		tagProductList() {
			const groupedData = [];
			this.reportdata.data.forEach((item) => {
				const branchKey = item.TagProduct //`${item.CategoryID} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.branchKey === branchKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.TagProduct);
				} else {
					groupedData.push({
						branchKey,
						//TagProduct: item.TagProduct,
						TagProduct: item.TagProduct
					});
				}
			});

			this.options.tagproductlist = groupedData
			//return groupedData;
		},

		keteranganList() {
			const groupedData = [];
			this.reportdata.data.forEach((item) => {
				const branchKey = item.Keterangan //`${item.CategoryID} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.branchKey === branchKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.Keterangan);
				} else {
					groupedData.push({
						branchKey,
						//Keterangan: item.Keterangan,
						Keterangan: item.Keterangan
					});
				}
			});

			this.options.keteranganlist = groupedData
			//return groupedData;
		},

		applyFilter() {
			this.loadData()
			this.getPiechart()
		},

		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

    },

	computed: {
		
	}
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.app-table {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  border-radius:4px;
}

.app-table td, .app-table th {
  border: 2px solid #fff/*#ddd*/;
  padding: 4px 10px;
}

.app-table tr:nth-child(even){background-color: #F1F4F8/*#D9E1F2*//*#f2f2f2*/;}

.app-table tr:hover {background-color:rgba(240, 240, 240, 1)  /*#ddd*/;}

.app-table th {
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: center;
  background-color: #0B0468/*#0070C0*/;
  color: white;
}

.th-yellow {
    font-weight:bold;
    color:#1E1E1E !important;
    font-size:16px;
    background: #FFFF00 !important;
}

.el-dialog__body {
    word-break: normal !important;
}

</style>